import { ReactComponent as Icon } from './menuIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const MenuIcon: React.FC<Props> = ({
  ariaLabel = 'menu',
  role = 'icon',
}) => {
  //todo:tema

  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'menu-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
